import React from 'react'
import './Dialogpause.css'
import Pause from "../../imgs/pause3d.png";
import Abort from "../../imgs/abort.png";
import Resume from "../../imgs/resume.png";
import Help from "../../imgs/help.png";

const Dialogpause = ({ message, onDialog, submessage,functionname }) => {
    const handledialog = ()=>{
        onDialog(true);
        functionname();
    }
    return (
        <div
            style={{
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                backgroundColor: "rgba(0,0,0,0.5)"
            }}
           
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    background: "white",
                    padding: "20px",
                    borderRadius: "10px",
                    backgroundColor: "whitesmoke"
                }}
            >
                <div className="dialogmain">
                    <div className="icondialog">
                        <img src={Pause} alt="" />
                    </div>
                    <span style={{ color: "#111", fontSize: "13px", fontWeight: "bold" }}>{message}</span>
                    <span style={{ marginTop: "4px", color: "black", fontSize: "16px" }}>{submessage}</span>
                   
                    <div className="scoredetails2">
                                <div onClick={() => onDialog(false)} className="scorerow2">
                                    <img src={Resume} alt="" />
                                    <span> Resume</span>
                                </div>
                                <div className='line' />
                                <div className="scorerow2">
                                    <img src={Help} alt="" />
                                    <span>Help</span>
                                </div>
                                <div className='line' />
                                <div onClick={handledialog}   className="scorerow2">
                                    <img src={Abort} alt="" />
                                    <span>Abort</span>
                                </div>
                                <div className='line' />
                            </div>
                </div>
            </div>
        </div>
    )
}

export default Dialogpause
